import isAfterDate from 'date-fns/is_after';
import { LOCALE } from 'helpers/i18n';
import {
  createAndChecker,
  createOrChecker,
  createNotChecker,
} from 'modules/redux-features';
import createCookies from 'helpers/cookies';

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "allowLocales": ["de", "nl"]
      }
    }
 */
export const allowLocales = (featureName, locales) => () => {
  return locales.indexOf(LOCALE) > -1;
};

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "afterTime": '2018-06-19T13:35:55.000Z'
      }
    }
 */
export const afterDate = (featureName, time) => () => {
  return isAfterDate(new Date(), new Date(time));
};

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "hasCookie": true
      },
      "myPersonalMagicalFeature2": {
        "hasCookie": 'special_cookie_name'
      }
    }
 */
export const hasCookie = (featureName, cookieName) => () => {
  try {
    const cookies = createCookies();

    cookieName = cookieName === true ? featureName : String(cookieName);

    return !!cookies.get(cookieName);
  } catch (e) {
    return false;
  }
};

const getChecker = (checkerName) => {
  const checker = checkersMapping[checkerName]; // eslint-disable-line no-use-before-define

  if (!checker) {
    throw new Error(
      `please define checker '${checkerName}' in checkersMapping`,
    );
  }

  return checker;
};

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "or": {"allowLocales": ["de", "es", "nl"], "hasCookie": true},
      }
    }
 */

export const or = createOrChecker(getChecker);

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "and": {"allowLocales": ["de", "es", "nl"], "afterTime": '12.12.2018'},
      }
    }
 */

export const and = createAndChecker(getChecker);

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "not": {"allowLocales": ["de", "es", "nl"], "afterTime": '12.12.2018'},
      }
    }
 */

export const not = createNotChecker(getChecker);

/**
 * "features": {
      "myPersonalMagicalFeature": {
        "isEnabled": some condition ? true : false,
      }
    }
 */

export const isEnabled = (featureName, value) => () => {
  return Boolean(value);
};

const checkersMapping = {
  afterDate,
  allowLocales,
  and,
  hasCookie,
  or,
  isEnabled,
  not,
};
